import React from 'react';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import Styles from './BancoAutoCarroDesktop.css';
import CustomEmblaCarouselHome24 from '@/components/organisms/CustomEmblaCarouselHome24';

function BancoAutoCarroDesktop() {
  return (
    <>
      <section id="banco-do-auto-carro" className="desktop">
        <ContainerHome24 className="container-carro">
          <img
            className="banco-do-auto-imagem"
            src="assets/banco-do-auto25/financiamento.svg"
            alt="ilustração financiamento"
          />
          <div>
            <h3 className="carro-title">Confira abaixo nossos tipos de financiamento:</h3>
            <CustomEmblaCarouselHome24
              // loop
              enableBullets
              detectBulletCount
              hideOverflow
              enableMobileArrows
              enablePrevArrow
              autoplay={100000}
            >
              {({ className }) => (
                <>
                  <div className={`slide ${className}`}>
                    <div>
                      <p className="carro-paragrafo">
                        <b>Financiamento direto com o dono</b>
                        <br />
                        <br />
                        No financiamento direto com o dono você pode financiar um veículo que
                        comprará de um conhecido, amigo ou até mesmo de um desconhecido na
                        WebMotors.
                      </p>
                      <a
                        className="link-banco-do-auto-carro"
                        href="financiamento-entre-particulares.html"
                      >
                        Saiba mais
                      </a>
                    </div>
                  </div>
                  <div className={`slide ${className}`}>
                    <div>
                      <p className="carro-paragrafo">
                        <b>Financiamento com uma loja</b>
                        <br />
                        <br />
                        No financiamento com uma <b>loja ou concessionária</b>, você pode financiar
                        de forma direta e contar com a confiança de ver e analisar seu veículo antes
                        de comprar. Simule com a gente e confira as lojas e concessionárias
                        parceiras do Santander no botão abaixo!
                      </p>
                      <a
                        className="link-banco-do-auto-carro"
                        href="https://www.cliente.santanderfinanciamentos.com.br/originacaocliente?int_source=portalSF&int_medium=banco-do-auto:tipos-de-financiamentos-simulador&int_campaign=saiba-mais"
                        target="_blank"
                      >
                        Saiba mais
                      </a>
                    </div>
                  </div>
                </>
              )}
            </CustomEmblaCarouselHome24>
          </div>
          <style jsx>{Styles}</style>
        </ContainerHome24>
      </section>
    </>
  );
}

export default BancoAutoCarroDesktop;
